export default "__VITE_ASSET__CLD74wv5__"